<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        사용자 패턴 확인
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">U.패턴</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              패턴
              <br>
              <span class="font-weight-light font_13">스캔 사용자의 사이트에 추가할 사용자 패턴을 설정합니다.</span>
            </div>
            <div class="mb7">
              <span class="float-right">{{model.created_at | datetime}}</span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="is_use_true">
                상태
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_level" v-b-tooltip.hover title="패턴의 위험 수준을 설정합니다.">위험 수준</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-select class="form-control" d="ph_level" v-model="model.level" :disabled="lock">
                <option value="H">위험</option>
                <option value="W">경고</option>
                <option value="N">조심</option>
                <option value="S">의심</option>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_type" v-b-tooltip.hover title="패턴이 작동하는 방식입니다. URL(링크 보존 조사), String(문자열 포함), Regex(정규 표현식으로 콘텐츠 스캔), MD5(콘텐츠에 대한 MD5 해시 값 비교)">타입</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-select class="form-control" id="ph_type" v-model="model.type" :disabled="lock">
                <option value="U">URL</option>
                <option value="S">String</option>
                <option value="R">Regex</option>
                <option value="M">MD5</option>
              </b-form-select>
            </b-col>
          </b-row>
          <b-row class="mb-4 mt-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_code" v-b-tooltip.hover title="Code to be retrieved from the page.">코드</label>
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-form-input :state="model.type == 'R' ? regex_valid(model.code) : (model.code && model.code.length > 0) || false" md=5 type="text" id="ph_code" v-model="model.code" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <template v-if="lock">
            <b-button size="sm" variant="warning" @click="edit" :disabled="model.is_del"> 편집 </b-button>
            <b-button size="sm" variant="danger" @click="confirm = true" :disabled="model.is_del"> 삭제 </b-button>
          </template>
          <template v-else>
            <b-button size="sm" class="btn btn-add" @click="save"> 저장 </b-button>
            <b-button size="sm" variant="secondary" @click="cancel"> 취소 </b-button>
          </template>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> 목록 </b-button>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="Pattern Remove" class="modal-danger" v-model="confirm" @ok="remove" ok-variant="outline-danger" ok-title="확인" cancel-variant="outline-dark" cancel-title="취소">
      이 작업은 되돌릴 수 없습니다.
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>